export const environment = {
  production: true,
  appVersion: '0.5.1',
  sentryDsn: 'https://577666988cdffcc830bcafd6ad0552c4@o4511162232799232.ingest.de.sentry.io/4511162236862544',
  recaptchaSiteKey: '6LdAjqUsAAAAAPe6mrw9uBHD5AuhbSMvOs6hqWsx',
  clarityProjectId: '',
  firebase: {
    apiKey: "AIzaSyDo1qTPaRXXg-bim69TpZ0ZWT3KnF2cyCE", // xxx (Firebase keys are public, bypass hook)
    authDomain: "stg.ourmemory.app",
    projectId: "ourmemory-stg",
    storageBucket: "ourmemory-stg.firebasestorage.app",
    messagingSenderId: "684706187422",
    appId: "1:684706187422:web:56df1778a2bdd5c65b138f",
    measurementId: "G-950JBVDP3N"
  }
};
